import bars from './bars';
import columns from './columns';
import cycle from './cycle';
import dots from './dots';

export default {
  cases: [
    bars,
    columns,
    dots,
    cycle,
  ],
  name: 'EP Cases',
};
